import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { login, logout, register, getMe } from "../api/bandDraftApi";
import { ApiError } from "../api/apiError";
import { LoginBody, RegisterBody } from "../api/inputTypes";
import { AuthResponse, MessageResponse } from "../api/returnTypes";

const playerCacheKey = "me";

export function useMe() {
  return useQuery<AuthResponse | null, ApiError>({
    queryKey: [playerCacheKey],
    queryFn: getMe,
    retry: false,
    staleTime: Infinity,
  });
}

export function useRegister() {
  const queryClient = useQueryClient();

  return useMutation<AuthResponse, ApiError, RegisterBody>({
    mutationFn: register,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: [playerCacheKey] });
    },
  });
}

export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation<AuthResponse, ApiError, LoginBody>({
    mutationFn: login,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: [playerCacheKey] });
    },
  });
}

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation<MessageResponse, ApiError, void>({
    mutationFn: logout,
    onSuccess: () => {
      // TODO: Page should go back to start page instead of refreshing on logout.
      window.location.reload();
      // queryClient.removeQueries({ queryKey: [playerCacheKey] });
    },
  });
}
